import { ExitingPersistence, FadeIn } from '@atlaskit/motion';
import AkSpinner from '@atlaskit/spinner';
import React from 'react';
import { ContentWrapper, Mask, SpinnerContainer } from "./styles";

const getSpinnerTestId = testId => {
  if (testId !== null && testId !== void 0 && testId.length) return "".concat(testId, "--spinner");
};

const SPINNER_MASK_DEFAULT_SIZE = 'large';
const SPINNER_MASK_DEFAULT_MIN_HEIGHT = 100;

const SpinnerMask = props => {
  const {
    active,
    appearance,
    children,
    className,
    delay,
    minHeight = SPINNER_MASK_DEFAULT_MIN_HEIGHT,
    size = SPINNER_MASK_DEFAULT_SIZE,
    testId
  } = props;
  return /*#__PURE__*/React.createElement(Mask, {
    minHeight: minHeight,
    "data-testid": testId,
    className: className
  }, /*#__PURE__*/React.createElement(ExitingPersistence, {
    appear: true
  }, active && /*#__PURE__*/React.createElement(FadeIn, null, fadeProps => /*#__PURE__*/React.createElement(SpinnerContainer, fadeProps, /*#__PURE__*/React.createElement(AkSpinner, {
    appearance: appearance,
    delay: delay,
    size: size,
    testId: getSpinnerTestId(testId)
  })))), /*#__PURE__*/React.createElement(ContentWrapper, {
    visible: !active
  }, children));
};

export default SpinnerMask;